import {Vector3, AlwaysDepth} from 'three'

import { attrKuiper, formatKuiper } from '../configEntities/groupsAttr.js'

import { colorSizeAleat } from './galaxy.js'


import meteourTexture from '../../../assets/textures/asteroids/asteroid.png'

import { pushShift } from '../groupsEntities/entitiesGroups.js'

import { Object } from './entitiesGroups.js'
import { randomNormal } from './asteroidsBelt.js'

import {sceneManager } from '../script.js'

import { animateParts } from '../utils/many-bodies.js'

import { randomNormal } from '../helpers.js'

export class Kuiper {
  constructor(centerElement) {
    this.name = 'Kuiper Belt'
    this.distCam = 12000
    this.qtd = 2000
    this.meteourTexture = meteourTexture
    this.blending = AlwaysDepth
    this.maxSpeed = 3e-4
    this.minSpeed = 9.6e-5
    this.inclSpeed = 1e-7
    this.speeds = []
    
    this.centerElement = centerElement

    this.coord = []
    this.colors = []
    this.sizes = []
    
    this.randValue = []
    this.shift = [];

    this.R = formatKuiper.R


    this.generateAttr(this.qtd, -0.35)
    this.generateAttr(this.qtd, 0.7)

    this.parameters= { coord:this.coord, colors: this.colors, sizes:this.sizes, shift:this.shift, randValue: this.randValue}

    this.element = new Object(
      this.name,
      this.distCam,
      this.labelPosition(),
      this.parameters,
      this.blending,
      this.meteourTexture,
    )
    sceneManager.commands.addParticlesHighlight(8e5, this.element)
  }

  generateAttr(numPoints, arc) {

    for (let i = 0; i < numPoints; i++) {
      const targetRMean = 0.5;
      const targetRStdDev = formatKuiper.r /2;  
      const targetR = Math.abs(randomNormal(targetRMean, targetRStdDev));
      const targetC = Math.random() * formatKuiper.r + formatKuiper.R

      const thetaMean = 0
      const thetaStdDev = Math.PI * formatKuiper.thetaSet
      const theta = randomNormal(thetaMean, thetaStdDev) * arc

      const phiMean = Math.PI
      const phiStdDev = Math.PI * formatKuiper.phiSet
      const phi = randomNormal(phiMean, phiStdDev) * arc

      const x = (targetC + 2*targetR * Math.cos(theta)) * Math.cos(phi)
      const z = (targetC + 2*targetR * Math.cos(theta)) * Math.sin(phi)
      const y = targetR * Math.sin(theta)

      let aleat = colorSizeAleat(attrKuiper)
      this.colors.push(aleat.color)
      this.sizes.push(aleat.size)
      this.randValue.push(Math.random() * 10.0*i)
      
      const randomSpeed = Math.random() * (this.maxSpeed - this.minSpeed) + this.minSpeed
      this.speeds.push(randomSpeed)

      pushShift(this.shift, 100);
      this.coord.push(new Vector3(x, y, z))
    }

  }
  labelPosition() {
    const position = new Vector3(formatKuiper.R, formatKuiper.r, formatKuiper.R)

    return position
  }
  centerOrbit() {
    this.element.objects.position.copy(this.centerElement.mesh.position)
  }
  animate(speed) {
    if (!this.element.objects) return;
    let distSun = sceneManager.camera.position.distanceTo(this.centerElement.mesh.position);
    this.centerOrbit()
    animateParts(
      this.element.objects,
      speed,
      this.speeds,
    );
    
    this.element.setLabelVisible(this.centerElement.mesh.position, sceneManager.camera, sceneManager.commands.controls.labels)
    this.element.pointMaterial.uniforms.time.value += speed*this.inclSpeed

    this.element.pointMaterial.uniforms.opacity.value = Math.max(0.1, Math.min(1, distSun / this.R));
    }
}
